<template>
    <gi-form
        v-if="form"
        ref="form"
        :form="form"
        :on-submit-fn="onSubmitFn"
        :history="history"
        :hide-actions="hideActions"
        @success="onSuccess"
        @error="onError"
        @form-error="onFormError"
        @load-history="onLoadHistory"
        @start-history-autosave="startHistoryAutosave"
        @stop-history-autosave="stopHistoryAutosave"
    >
        <template v-if="!hideHeader" #header>
            <app-page-header class="mb-4" />
        </template>
        <template #fields="{ loading }">
            <field-group-organisation
                ref="organisation"
                :value="form"
                :loading="loading"
                require-company-info
                @input="setFormData"
            />

            <field-string
                ref="trading_name"
                v-model="form.trading_name"
                :disabled="loading"
                :label="$t('trading_name')"
            />

            <field-description
                ref="overview"
                v-model="form.overview"
                :disabled="loading"
                :label="$t('overview')"
                wysiwyg
                required
            />

            <v-row :no-gutters="$vuetify.breakpoint.smAndDown" class="stacked">
                <v-col md="4" cols="12">
                    <field-money
                        ref="market_cap_recorded"
                        v-model="form.market_cap_recorded"
                        :disabled="loading"
                        :label="$t('market_cap_recorded')"
                        required
                    />
                </v-col>
                <v-col md="4" cols="12">
                    <field-market-cap-source
                        ref="market_cap_source"
                        v-model="form.market_cap_source"
                        :disabled="loading"
                        :label="$t('market_cap_source')"
                        required
                    />
                </v-col>
                <v-col md="4" cols="12">
                    <field-percentage
                        ref="target_return"
                        v-model="form.target_return"
                        :disabled="loading"
                        :label="$t('target_return')"
                        required
                    />
                </v-col>
            </v-row>

            <v-row :no-gutters="$vuetify.breakpoint.smAndDown" class="stacked">
                <v-col md="6" cols="12">
                    <field-lookup
                        ref="business_stage_id"
                        v-model="form.business_stage_id"
                        type="business-stage"
                        :disabled="loading"
                        :label="$t('business_stage')"
                        required
                    />
                </v-col>
                <v-col md="6" cols="12">
                    <field-lookup
                        ref="investment_strategy_id"
                        v-model="form.investment_strategy_id"
                        type="investment-strategy"
                        :disabled="loading"
                        required
                        :label="$t('investment_strategy')"
                    />
                </v-col>
            </v-row>

            <field-toggle
                ref="is_vct_fund"
                v-model="form.is_vct_fund"
                :disabled="loading"
                :label="$t('is_this_company_a_vct_fund')"
            />

            <field-group-vct-stats v-if="form.is_vct_fund" v-model="form.vct_stats" :loading="loading" />
        </template>
        <template v-if="prependCancelButton" #prepend-actions>
            <app-button-cancel @click="onCancel" />
        </template>
    </gi-form>
</template>

<script>
import form from '@/mixins/form';
import history from '@/mixins/history';
import { Company } from '@/models';

export default {
    name: 'CreateCompany',
    components: {
        GiForm: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/forms/Form'
            ),
        FieldGroupOrganisation: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/groups/Organisation'
            ),
        FieldGroupVctStats: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/groups/VctStats'
            ),
        FieldMarketCapSource: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/MarketCapSource'
            )
    },
    mixins: [form, history],
    data: () => ({
        id: 'CreateCompany',
        model: Company
    }),
    watch: {
        'form.is_vct_fund'(active) {
            if (!active && this.form) {
                this.form.vct_stats = {};
            }
        }
    }
};
</script>
